import { download, generateCsv, mkConfig } from "export-to-csv";

const downloadCSV = (data: any) => {
  if (!data) return;
  const csvConfigPre = mkConfig({
    fieldSeparator: ",",
    quoteStrings: true,
    decimalSeparator: ".",
    showColumnHeaders: true,
    filename: `inventory-archiver-export`,
    useTextFile: false,
    useKeysAsHeaders: true,
    useBom: true
  });
  const csv = generateCsv(csvConfigPre)(data);
  download(csvConfigPre)(csv);
};

export default downloadCSV;
